import { ModalProps } from '../modal';
import { ModalFull } from '../modal-full';
import { LoadingAnimation } from './animation';

export type ISpinnerModalProps = ModalProps;

export const SpinnerModal = (props: ISpinnerModalProps) => {
  return (
    <ModalFull {...props}>
      <LoadingAnimation></LoadingAnimation>
    </ModalFull>
  );
};
